<template>
    <div class="culture-explore">
        <div class="culture-explore-header">
            <router-link class="culture-explore-header__close-btn-link" to="/culture">
                <img class="culture-explore-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>

            <ul class="culture-explore-header__anchor-list">
                <li class="culture-explore-header__anchor-item">
                    <button class="culture-explore-header__anchor-btn" v-on:click="onAnchorClick('about')">About</button>
                </li>

                <li class="culture-explore-header__anchor-item">
                    <button class="culture-explore-header__anchor-btn" v-on:click="onAnchorClick('philosophy')">Philosophy</button>
                </li>
                <li class="culture-explore-header__anchor-item">
                  <button class="culture-explore-header__anchor-btn" v-on:click="onAnchorClick('diversity')">Diversity</button>
                </li>
                <li class="culture-explore-header__anchor-item">
                    <button class="culture-explore-header__anchor-btn" v-on:click="onAnchorClick('leadership')">Leadership</button>
                </li>
            </ul>

            <div class="culture-explore-header__content-container">
                <div class="culture-explore-header__content">        
                    <h2 class="culture-explore-header__heading">WE ARE</h2>
                    <img class="culture-explore-header__logo-image" src="/assets/imgs/hunter-white-large.png" alt="Hunter">
                    <p class="culture-explore-header__paragraph">A strategic and creative communications partner earning attention and elevating corporate reputation for leading brands around the world.</p>
                </div>
            
                <img class="culture-explore-header__play-button" v-on:click="onPlayButtonClick" src="/assets/imgs/video-play-button.png" alt="Play">

                <picture>
                    <source media="(max-width: 640px)" srcset="/assets/imgs/culture-video-mobile.jpg">
                    <source media="(min-width: 641px)" srcset="/assets/imgs/culture-video.jpg">
                    <img class="culture-explore-header__placeholder-image" src="/assets/imgs/culture-video.jpg" alt="Two employees at the Hunter integrated marketing and PR firm in NYC developing a client campaign.">
                </picture>
            </div>

            <div class="culture-explore-header__video-container">
                <img class="culture-explore-header__video-close-btn" v-on:click="onVideoCloseBtnClick" src="/assets/imgs/close.png" alt="Close">

                <div class="culture-explore-header__video">

                </div>
            </div>
        </div>

        <div id="about" class="culture-explore-about">
            <h2 class="culture-explore-about__heading">ABOUT</h2>

            <div class="culture-explore-about__headline-container">
                <div class="culture-explore-about__img-container">
                    <img class="culture-explore-about__img" src="/assets/imgs/H-red.png" alt="H">
                </div>
                <h2 class="culture-explore-about__headline">You've known us as Hunter Public Relations, but the needs of our clients have evolved and so have we.</h2>
            </div>

            <p class="culture-explore-about__paragraph">Born from a foundation in traditional consumer <a href="/expertise/solutions/pr">PR</a>, we offer a wide range of integrated marketing communications services across owned, earned, and paid channels. And while helping brands “relate” to their “public” will always be at the heart of what we do, the scalable <a href="/expertise/solutions">solutions</a> that we offer are limited only by the ever-changing media and shopping behaviors of consumers, our clients’ challenges, and the passions of our talented staff.</p>
        </div>
  
        <div class="culture-explore-collage-image__container">
            <img class="culture-explore-collage-image" src="/assets/imgs/culture-collage.png" alt="Employees at the Hunter integrated marketing and public relations agency in New York posing at staff social events.">
        </div>
  
        <div id="philosophy" class="culture-explore-philosophy">
            <div class="culture-explore-philosophy_wrapper">
                <h2 class="culture-explore-philosophy__heading">Philosophy</h2>

                <div class="culture-explore-philosophy__content-container">
                    <h2 class="culture-explore-philosophy__slogan-heading"><strong>Our motto at HUNTER:</strong></h2>
                    <p class="culture-explore-philosophy__slogan">We Earn It, and this comes to life in every area of our business and how we approach yours.</p>
                </div>
                
                <div class="culture-explore-philosophy__content-container">
                    <h3 class="culture-explore-philosophy__sub-heading">EARNING ATTENTION:</h3>
                    <p class="culture-explore-philosophy__paragraph">In a world where the average person touches their phone more than 200 times per day (scary, isn't it?), we believe that their attention can never be "bought."  Even through our work in paid and owned channels, it is always earned. Hunter's foundation in public relations trained us to tell brand stories authentically and editorially and create engaging and relevant content delivered through trusted mouthpieces.</p>
                </div>    
                
                <div class="culture-explore-philosophy__content-container">
                    <h3 class="culture-explore-philosophy__sub-heading">EARNING CLIENT RELATIONSHIPS:</h3>
                    <p class="culture-explore-philosophy__paragraph">We know that decades-long client relationships have to be earned. Each. And. Every. Day. Our first client when we were founded over 30 years ago is still with us (yup!). Five have been with us for 10 years or more. Many others took us with them when they moved to new companies, new <a href="/expertise/specialties">industries</a>, and new territories seeking new solutions from us for their marketing challenges outside of “traditional PR.” We've been told we have an intense focus on client-service. That's how we grow together.</p>
                </div>    
                
                <div class="culture-explore-philosophy__content-container">
                    <h3 class="culture-explore-philosophy__sub-heading">EARNING STAFF DEDICATION:</h3>
                    <p class="culture-explore-philosophy__paragraph">We are HUNTERS: writers and researchers, makers and creators, connectors and collaborators, dreamers and problem solvers. Our talented <a href="/contact/be-a-hunter">staff</a> are all we've “got,” and they have a lot of choices today; they could even come to work for you! We'd rather they stay with us a long time, and our average <a href="/contact/be-a-hunter">staff</a> tenure is one of the highest in the industry because we know that dedication to being a HUNTER, and all that means, is something we can never take for granted. So, we work really hard at that too.</p></p>
                </div>
            </div>


          <div id="diversity" class="culture-explore-diversity">
            <div class="culture-explore-diversity_wrapper">
              <h2 class="culture-explore-diversity__heading">Diversity, Equity and Inclusion</h2>

              <div class="culture-explore-diversity__content-container">
                <p class="culture-explore-diversity__paragraph">At HUNTER, we believe in creating a culture of belonging where everyone can thrive. Empowering our staff and celebrating their differences helps to drive our work that matters, whether that is work for our clients or for our agency. </p>
              </div>

              <div class="culture-explore-diversity__content-container">
                <p class="culture-explore-diversity__paragraph">We embrace our employees’ differences in age, race, ethnicity, family or marital status, gender identity or expression, language, national origin, physical and mental ability, political affiliation, religion, sexual orientation, socio-economic status, and other characteristics that make us unique. </p>
              </div>

              <div class="culture-explore-diversity__content-container">
                <p class="culture-explore-diversity__paragraph">
                  Real change isn’t easy, and we understand that integrating DEI practices into our company culture will take time and an unwavering commitment to progress. You can read our full Diversity, Equity, and Inclusion statement <a href="https://hunterpr.com/dei/">here</a>.
                </p>
                </p>
              </div>
            </div>
          </div>
            
            <div id="leadership" class="culture-explore-leadership">
                <h2 class="culture-explore-leadership__heading">Leadership</h2>

                <ul class="culture-explore-leadership__list">
                    <li v-for="leadership in leadershipArray" class="culture-explore-leadership__item">
                        <div class="culture-explore-leadership__image-container" :class="{hasHover: (leadership.tags.length > 0)}">
                            <img class="culture-explore-leadership__image" :src="leadership.image">

                            <ul class="culture-explore-leadership__tags-list">
                                <li class="culture-explore-leadership__tags-item" v-for="tag in leadership.tags">
                                    <button class="culture-explore-leadership__tags-btn">{{tag}}</button>
                                </li>
                            </ul>
                        </div>

                        <h2 class="culture-explore-leadership__name" v-html="leadership.name"></h2>

                        <p class="culture-explore-leadership__roles" v-html="leadership.role"></p>
                    </li>
                </ul>
            </div>

            <div class="culture-explore-latest-news">
                <h2 class="culture-explore-latest-news__heading">Latest News</h2>

                <ul class="culture-explore-latest-news__list">
                    <li v-for="newsEntry in newsEntryItems.slice(0, 3)" class="culture-explore-latest-news__item">
                        <div class="culture-explore-latest-news__container">
                            <div class="culture-explore-latest-news__article-heading-container">
                                <h2 class="culture-explore-latest-news__article-heading" v-html="newsEntry.headline"></h2>
                            </div>

                            <div class="culture-explore-latest-news__paragraph-container">
                                <div class="culture-explore-latest-news__paragraph-wrapper">
                                    <p class="culture-explore-latest-news__paragraph" v-html="newsEntry.preview"></p>

                                    <a v-if="newsEntry.linkType === 'link'" class="culture-explore-latest-news__link" :href=newsEntry.url target="_blank">Read More</a>
                                    <router-link v-else :to="newsEntry.url" class="culture-explore-latest-news__link">Read More</router-link>
                                </div>
                            </div>

                            <img class="culture-explore-latest-news__image" :src="newsEntry.thumbnail">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
  
        <div class="culture-explore-footer">
            <h2 class="culture-explore-footer__heading">Learn more...</h2>
            <div class="culture-explore-footer__link-container">
                <a href="/work/case-studies" class="culture-explore-footer__link">Work</a>
                <a href="/expertise/explore" class="culture-explore-footer__link">Expertise</a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .culture-explore {
        background-color: #003a4a;
        color: #ffffff;
        overflow-x: hidden;
        position: relative;
    }

    .culture-explore-header {
        height: 0;
        overflow: hidden;
        position:relative;
        width:100%;
    }

    .culture-explore-header__content-container {
        position: relative;

        @media @breakpoint__mobile--large {
            height: 100vh;
        }
    }

    .culture-explore-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .culture-explore-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .culture-explore-header__anchor-list {
        margin: 0;
        padding: 0;
        position: absolute;
        text-align: center;
        top: 80px;
        width: 100%;
        z-index: 10;
    }

    .culture-explore-header__anchor-item {
        display: inline-block;
        padding: 0 15px;

        @media @breakpoint__tablet--small {
            padding: 0 5px;
        }

        &:nth-child(2) {
          border-left: solid 2px #e40046;
          border-right: solid 2px #e40046;
        }
        &:nth-child(3) {  
          border-right: solid 2px #e40046;
        }
  }

  .culture-explore-header__anchor-btn {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: block;
  font-family: Flama, Arial, Helvetica, sans-serif;
  font-size: 18px;
  letter-spacing: 0.3px;
  padding: 0;
  text-decoration: none;
  text-transform: uppercase;

  @media @breakpoint__tablet--small {
  font-size: 14px;
  }
  }

  .culture-explore-header__content {
  box-sizing: border-box;
  left: 0;
  margin: auto;
  max-width: 1300px;
  padding: 0 50px;
  position: absolute;
  right: 0;
  top: 55%;
  transform: translateY(-50%);
  width: 100%;
  z-index: 10;

  @media @breakpoint__tablet--medium {
  top: 45%;
  }

  @media @breakpoint__mobile--large {
  box-sizing: border-box;
  left: 0;
  padding: 0 20px;
  top: 45%;
  width: 100%;
  }
  }

  .culture-explore-header__heading {
  color: #e40046;
  font-family: Flama-Bold, Arial, Helvetica, sans-serif;
  font-size: 40px;
  line-height: 1;
  margin: 0 0 20px;

  @media @breakpoint__tablet--large {
  font-size: 26px;
  }

  @media @breakpoint__tablet--medium {
  font-size: 36px;
  }

  @media @breakpoint__mobile--large {
  font-size: 32px;
  }
  }

  .culture-explore-header__logo-image {
  margin-bottom: 20px;
  width: 375px;

  @media @breakpoint__tablet--large {
  width: 260px;
  }

  @media @breakpoint__tablet--medium {
  width: 330px;
  }

  @media @breakpoint__tablet--small {
  width: 100%;
  }
  }

  .culture-explore-header__paragraph {
  font-size: 22px;
  line-height: 1.4;
  margin: 0;
  width: 430px;

  @media @breakpoint__tablet--large {
  font-size: 15px;
  width: 275px;
  }

  @media @breakpoint__tablet--medium {
  font-size: 20px;
  width: 80%;
  }

  @media @breakpoint__tablet--small {
  width: 100%;
  }

  @media @breakpoint__mobile--large {
  font-size: 18px;
  }
  }

  .culture-explore-header__placeholder-image {
  position: relative;
  width: 100%;
  z-index: 0;

  @media @breakpoint__tablet--medium {
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  }

  @media @breakpoint__tablet--small {
  width: 100%;
  }

  @media @breakpoint__mobile--large {
  width: auto;
  }
  }

  .culture-explore-header__play-button {
  cursor: pointer;
  left: 50%;
  opacity: 0;
  position: absolute;
  transform: translate(-50%, -50%);
  transition: 0.3s opacity;
  top: 55%;
  z-index: 10;

  &:hover {
            opacity: 0.6 !important;
        }

        @media @breakpoint__tablet--medium {
            top: 70%;
        }

        @media @breakpoint__mobile--large {
            top: 80%;
        }
    }

    .culture-explore-header__video-container {
        background-color: #003a4a;;
        display: none;
        position: relative;
        width: 100%;
        z-index: 300;

        .culture-explore-header__video-close-btn {
            cursor: pointer;
            display: block;
            left: 25px;
            position: absolute;
            top: 20px;
            z-index: 100;

            @media @breakpoint__mobile--large {
                left: 15px;
            }
        }
    }

    .culture-explore__heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 0.38px;
        line-height: 1;
        margin: 0 0 40px 0;
        text-transform: uppercase;

        @media @breakpoint__mobile--large {
            font-size: 1.4em;
            margin-bottom: 30px;
        }
    }

    .culture-explore-about {
        box-sizing: border-box;
        margin: 0 auto;
        max-width: 1300px;
        padding: 60px 50px;
        width: 100%;

        @media @breakpoint__mobile--large {
            padding: 60px 20px;
        }
    }

    .culture-explore-about__heading {
        .culture-explore__heading();
        opacity: 0;
        transform: translateY(-40%);
    }

    .culture-explore-about__headline-container {
        display: flex;
        margin-bottom: 20px;
        opacity: 0;
        transform: translateY(-20%);

        @media @breakpoint__mobile--large {
            display: block;
        }
    }

    .culture-explore-about__img-container {
        margin-bottom: 30px;
    }

    .culture-explore-about__img {
        margin-right: 30px;
        width: 100px;
    }

    .culture-explore-about__headline {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 0.5px;
        margin: 0 0 20px 0;
        max-width: 800px;

        @media @breakpoint__mobile--large {
            font-size: 1.2em;
        }
    }

    .culture-explore__paragraph {
        color: #003a4a;
        font-size: 18px;
        letter-spacing: 0.2px;
        line-height: 2;
        margin: 0;
        max-width: 1000px;

        @media @breakpoint__mobile--large {
            font-size: 0.9em;
        }
    }

    .culture-explore-about__paragraph {
        .culture-explore__paragraph();
        color: #ffffff;
        opacity: 0;
        transform: translateY(-20%);
    }

    .culture-explore-collage-image__container {
        opacity: 0;
        position: relative;

        &:after {
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-size: 200px;
  border-top-left-radius: 150px;
  border-top-right-radius: 150px;
  bottom: 0;
  content: "";
  position: absolute;
  height: 50%;
  width: 100%;

  @media @breakpoint__mobile--large {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  }
  }
  }

  .culture-explore-collage-image {
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
  max-width: 1300px;
  padding: 0 50px;
  position: relative;
  width: 100%;
  z-index: 100;

  @media @breakpoint__mobile--large {
  padding: 0 20px;
  }
  }

  .culture-explore-philosophy {
  background-color: #ffffff;
  border-radius: 0 0 150px 150px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 80px 0 40px;
  opacity: 0;
  width: 100%;

  @media @breakpoint__tablet--medium {
  border-radius: 0 0 100px 100px;
  }

  @media @breakpoint__mobile--large {
  border-radius: 0 0 50px 50px;
  }
  }

  .culture-explore-philosophy_wrapper {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1300px;
  padding: 0 50px;
  width: 100%;

  @media @breakpoint__mobile--large {
  padding: 0 20px;
  }
  }

  .culture-explore-philosophy__content-container {
  margin-bottom: 45px;
  }

  .culture-explore-philosophy__heading {
  .culture-explore__heading();
  color: #003a4a;
  }

  .culture-explore-philosophy__slogan-heading {
  .culture-explore__heading();
  color: #e40046;
  margin-bottom: 15px;
  text-transform: none;

  @media @breakpoint__mobile--large {
  margin-bottom: 15px;
  }
  }

  .culture-explore-philosophy__slogan {
  .culture-explore__heading();
  color: #003a4a;
  line-height: 1.5;
  margin-bottom: 50px;
  max-width: 750px;
  text-transform: none;
  }

  .culture-explore__sub-heading {
  color: #e40046;
  flex: none;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0 0 20px;
  }

  .culture-explore-philosophy__sub-heading {
  .culture-explore__sub-heading();
  }

  .culture-explore-philosophy__paragraph {
  .culture-explore__paragraph();
  }



  .culture-explore-diversity {
  background-color: #ffffff;
  border-radius: 0 0 150px 150px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 80px 0 40px;
  width: 100%;

  @media @breakpoint__tablet--medium {
  border-radius: 0 0 100px 100px;
  }

  @media @breakpoint__mobile--large {
  border-radius: 0 0 50px 50px;
  }
  }

  .culture-explore-diversity_wrapper {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1300px;
  padding: 0 50px;
  width: 100%;

  @media @breakpoint__mobile--large {
  padding: 0 20px;
  }
  }

  .culture-explore-diversity__content-container {
  margin-bottom: 45px;
  }

  .culture-explore-diversity__heading {
  .culture-explore__heading();
  color: #003a4a;
  }

  .culture-explore-diversity__slogan-heading {
  .culture-explore__heading();
  color: #e40046;
  margin-bottom: 15px;
  text-transform: none;

  @media @breakpoint__mobile--large {
  margin-bottom: 15px;
  }
  }

  .culture-explore-diversity__slogan {
  .culture-explore__heading();
  color: #003a4a;
  line-height: 1.5;
  margin-bottom: 50px;
  max-width: 750px;
  text-transform: none;
  }

  .culture-explore__sub-heading {
  color: #e40046;
  flex: none;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0 0 20px;
  }

  .culture-explore-diversity__sub-heading {
  .culture-explore__sub-heading();
  }

  .culture-explore-diversity__paragraph {
  .culture-explore__paragraph();
  }






  .culture-explore-leadership {
  max-width: 1300px;
  margin: 0 auto 50px;
  padding: 60px 0 0;
  position: relative;
  width: 100%;
  z-index: 10;
  }

  .culture-explore-leadership__heading {
  .culture-explore__heading();
  color: #003a4a;
  padding: 0 50px;

  @media @breakpoint__mobile--large {
  padding: 0 20px;
  }
  }

  .culture-explore-leadership__list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  }

  .culture-explore-leadership__item {
  box-sizing: border-box;
  display: inline-block;
  list-style-type: none;
  margin: 0 50px 50px;
  transform: translateY(20px);
  width: calc(~"(100% / 3) - (100px / 3 * 2)");
  vertical-align: top;

  .culture-explore-leadership__image {
  display: block;
  width: 100%;
  }

  &:nth-child(3n+2) {
            margin: 0;
        }

        @media @breakpoint__tablet--large {
            width: calc(~"(100% / 2) - (75px)");

            &:nth-child(3n+2) {
                margin: 0 50px 50px;
            }

            &:nth-child(2n+2) {
                margin-left: 0;
            }
        }

        @media @breakpoint__tablet--small {
            padding: 0 50px 50px;
            margin: 0 !important;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            padding: 0 20px 25px;
        }
    }

    .culture-explore-leadership__image-container {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        border-radius: 55px;
        display: block;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;

        &:before {
            content: "";
            background-color: #003A4A;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            transition: 0.5s opacity;
            top: 0;
            width: 100%;
        }

        &.hasHover {
            &:hover {
                &:before {
                    opacity: 0.78;
                }

                .culture-explore-leadership__tags-list {
                    opacity: 1;
                }
            }
        }
    }

    .culture-explore-leadership__image {
        display: block;
        width: 100%;
    }

    .culture-explore-leadership__tags-list {
        box-sizing: border-box;
        list-style-type: none;
        margin: 0 auto;
        opacity: 0;
        padding: 0 20px;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translateY(-50%);
        transition: opacity 0.5s;
        width: 100%;
    }

    .culture-explore-leadership__tags-item {
        display: inline-block;
    }

    .culture-explore-leadership__tags-btn {
        border: 1px solid #e40046;
        border-radius: 5px;
        background: none;
        color: #ffffff;
        cursor: default;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 1;
        margin: 0 5px 10px 5px;
        padding: 5px;
        text-transform: uppercase;
        transition: 0.3s all;
    }

    .culture-explore-leadership__name {
        color: #e40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        letter-spacing: 0.3px;
        margin: 0 0 10px;
        text-transform: uppercase;
    }

    .culture-explore-leadership__roles {
        color: #7D7D7D;
        font-size: 16px;
        line-height: 1.4;
        margin: 0;
    }

    .culture-explore-latest-news {
        margin: 0 auto 60px;
        max-width: 1300px;
        position: relative;
        z-index: 10;
    }

    .culture-explore-latest-news__heading {
        .culture-explore__heading();
        color: #003a4a;
        padding: 0 50px;

        @media @breakpoint__tablet--small {
            padding: 0 50px 0;
        }

        @media @breakpoint__mobile--large {
            padding: 0 20px 0;
        }
    }

    .culture-explore-latest-news__list {
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        width: 100%;
    }

    .culture-explore-latest-news__item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 50px 50px;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (100px / 3 * 2)");
        vertical-align: top;

        .culture-explore-latest-news__image {
            display: block;
            width: 100%;
            height: 300px;
            object-fit: cover;
        }

        &:nth-child(3n+2) {
            margin: 0;
        }

        @media @breakpoint__tablet--large {
            width: calc(~"(100% / 2) - (75px)");

            &:nth-child(3n+2) {
                margin: 0 50px 50px;
            }

            &:nth-child(2n+2) {
                margin-left: 0;
            }
        }

        @media @breakpoint__tablet--medium {
            margin: 0 !important;
            padding: 0 50px 50px;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            padding: 0 20px 25px;
        }
    }

    .culture-explore-latest-news__container {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background-color: #386572;
        border-radius: 55px;
        display: block;
        overflow: hidden;
        position: relative;

        @media @breakpoint__tablet--small {
            border-radius: 50px;
        }

        @media @breakpoint__tablet--medium{
            border-radius: 50px;
        }

        &:before {
            content: "";
            background-color: #304449;
            height: 100%;
            left: 0;
            opacity: 0.72;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
        }     

        &:hover {
            .culture-explore-latest-news__article-heading-container {
                transform: translateY(-100%);
            }
            .culture-explore-latest-news__paragraph-container {
                transform: translateY(-100%);
            }
        }

        @media @breakpoint__tablet--large {
            &:before {
                opacity: 0.6;
            }
        }
    }

    .culture-explore-latest-news__article-heading-container {
        height: 100%;
        left: 0;
        position: absolute;
        text-align: left;
        top: 0;
        transition: 0.5s transform;
        width: 100%;
        z-index: 10;
    }

    .culture-explore-latest-news__article-heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.4em;
        letter-spacing: 1px;
        margin: 0 auto;
        padding-bottom: 20px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 80%;

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 30%;
        }

        @media @breakpoint__tablet--medium{
            font-size: 1.6em;
        }
    }

    .culture-explore-latest-news__paragraph-container {
        height: 100%;
        left: 0;
        margin: 0 auto;
        position: absolute;
        text-align: left;
        right: 0;
        top: 100%;
        transition: 0.5s transform;
        width: 80%;
        z-index: 10;
    }

    .culture-explore-latest-news__paragraph-wrapper {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .culture-explore-latest-news__paragraph {
        color: #fff;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.4;
        margin: 0 0 20px;
        position: relative;

        @media @breakpoint__tablet--medium{
            font-size: 15px;
        }
    }

    .culture-explore-latest-news__link {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 23px;
        margin: 0;
        padding: 1px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.5s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #ffffff;
            color: #003a4a;
        }
    }

    .culture-explore-footer {
        background: #003a4a;
        opacity: 0;
        padding: 60px 20px;
    }

    .culture-explore-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 1px;
        line-height: 1;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .culture-explore-footer__link-container {
        display: block;
        text-align: center;
    }

    .culture-explore-footer__link {
        background-color: #e40046;
        border: none;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        letter-spacing: 1px;
        padding: 10px 30px;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>

<script src="https://player.vimeo.com/api/player.js"></script>

<script>
    export default {
        name: "CultureExplore",
        data() {
            return {
                leadershipArray : [],
                newsEntryItems : []
            }
        },
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initLeadership(vm.$parent.modelLeadership);
                    vm.initLatestNews(vm.$parent.modelNews);
                    vm.initAnimIn();
                    vm.initSubTitle();

                    setTimeout(function()
                    {
                        if (vm.$route.params.anchor !== "explore")
                        {
                            vm.onRouteChange(vm.$route.params.anchor);
                        }
                    }, 1000);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initLeadership : function(data)
            {
                for (var i = 0; i < data.length; i++)
                {
                    var leadership = {};
                    leadership.image = data[i].Image;
                    leadership.imageAltText = data[i].ImageAltText;
                    leadership.name = data[i].Name;
                    leadership.role = data[i].Role;
                    leadership.tags = data[i].Tags;
                    this.leadershipArray.push(leadership);
                }
            },
            initLatestNews : function(data)
            {
                var newsData = data;
                this.newsEntryItems = [];

                for(var i = 0; i < 3; i++)
                {
                    var newsEntry = {};
                    newsEntry.headline = newsData[i].Headline;
                    newsEntry.thumbnail = newsData[i].ArticleImageThumbnail;
                    newsEntry.thumbnailAltText = newsData[i].ArticleImageAltText;
                    newsEntry.preview = newsData[i].ArticlePreview;
                    newsEntry.linkType = newsData[i].ArticleLinkType;

                    if(newsEntry.linkType === "link")
                    {
                        newsEntry.url = newsData[i].ArticleLink;
                    }
                    else
                    {
                        newsEntry.url = "/news/" + newsData[i].ArticleLink;
                    }

                    this.newsEntryItems.push(newsEntry);
                }
            },
            initAnimIn : function()
            {
                TweenMax.set(".culture-explore-header", {height:"auto"});
                TweenMax.from(".culture-explore-header", 0.6, {height:0, ease: Power2.easeOut});

                var tl = new TimelineMax();
                tl.from(".culture-explore-header__content", 0.5, {transform: "translateY(20px)", opacity: 0}, "+=0.5");
                tl.to(".culture-explore-header__play-button", 0.3, {opacity: 1}, "-=0.2");
                tl.from(".culture-explore__close-btn", 0.6, {transform: "scale(0)", ease: Back.easeOut.config(2)}, "-=0.2");
                tl.to(".culture-explore-about__heading", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.3");
                tl.to(".culture-explore-about__headline-container", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.3");
                tl.to(".culture-explore-about__paragraph", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.3");
                tl.to(".culture-explore-collage-image__container", 0.5, {opacity: 1}, "-=0.1");
                tl.to(".culture-explore-philosophy", 0.5, {opacity: 1}, "-=0.5");
                tl.to(".culture-explore-footer", 0.5, {opacity: 1});
            },
            initSubTitle : function()
            {
                document.querySelector(".header__logo-sub-title").innerHTML = "Culture";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            onAnchorClick : function(value)
            {
                if (value === this.$router.history.current.params.anchor)
                {
                    this.onRouteChange(value);
                }
                else
                {
                    this.$router.push("/culture/" + value);
                }
            },
            onRouteChange : function(anchor)
            {
                TweenMax.to(window, 1.6, {scrollTo:{y: "#" + anchor}, autoKill: false, ease: Power4.easeInOut});
            },
            onPlayButtonClick : function()
            {
                var tl = new TimelineMax();
                tl.to(".culture-explore-header__content-container", 0.2, {opacity: 0});
                tl.set(".culture-explore-header__content-container", {display: "none"});
                tl.set(".culture-explore-header__video-container", {opacity:1, display: "block"});
                
                document.querySelector(".culture-explore-header__video").innerHTML = '<div id="sizzle-reel" style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/875613080?color=e40046&title=0&byline=0&portrait=0&autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay; encrypted-media"></iframe></div>';
            },
            onVideoCloseBtnClick :function()
            {
                var tl = new TimelineMax();
                tl.set(".culture-explore-header__content-container", {display: "block"});
                tl.to(".culture-explore-header__video-container", 0.2, {opacity:0});
                tl.set(".culture-explore-header__video-container", {display: "none"});
                tl.to(".culture-explore-header__content-container", 0.5, {opacity:1});
                document.querySelector(".culture-explore-header__video").innerHTML = "";
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                this.onRouteChange(this.$route.params.anchor);
            }
        }
    };
</script>
